import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '@/lib/axios';
import { getSocket } from '@/lib/socket';
import { useAuthStore } from '@/store/auth.store';
import { ROL } from '@/store/auth.store';

export function usePresencia() {
  const usuario = useAuthStore(s => s.usuario);
  const esMedico = usuario?.rolId === ROL.MEDICO || usuario?.rolId === ROL.MEDICO_ADMIN || usuario?.rolId === ROL.SUPER_ADMIN;

  const [onlineIds, setOnlineIds] = useState<Set<string>>(new Set());

  // Estado inicial desde REST
  const { data } = useQuery<{ onlineIds: string[] }>({
    queryKey: ['chat-presencia'],
    queryFn: () => api.get('/api/chat/presencia').then(r => r.data),
    enabled: esMedico,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (data?.onlineIds) setOnlineIds(new Set(data.onlineIds));
  }, [data]);

  // Actualizaciones en tiempo real
  useEffect(() => {
    if (!esMedico) return;
    const socket = getSocket();

    function onCambio({ medicoId, online }: { medicoId: string; online: boolean }) {
      setOnlineIds(prev => {
        const next = new Set(prev);
        if (online) next.add(medicoId);
        else next.delete(medicoId);
        return next;
      });
    }

    socket.on('presencia:cambio', onCambio);
    return () => { socket.off('presencia:cambio', onCambio); };
  }, [esMedico]);

  return onlineIds;
}
